<template>
    <div class="relative">
        <div class="page page-intro d-flex" id="highlights">
            <page-header class="home-header"/>
            <side-nav class="home-sidebar"/>
            <div class="row align-items-center h-100 w-100">
                <div class="col-12">
                    <div class="d-flex">
                        <div class="row align-items-center w-100 no-gutters">
                            <div class="col-10 col-sm-6 offset-1 offset-sm-3">
                                <div class="about">
                                    <p class="title liviomono home-title">An emerging leader in automotive technology.</p>
                                    <p class="subtext livionorm home-subtext">We’re a team of engineers, developers, project managers, and creators. We are the project maintainer of SmartDeviceLink and a subsidiary of Ford, actively contributing to projects within Connected Vehicle Platform & Products.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
import SideNav from './shared/SideNav.vue'
export default {
    data () {
        return {};
    },
    components: {
        "page-footer": Footer,
        "page-header": Header,
        "side-nav": SideNav,
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue